import api from '../../plugins/api';

// ÐÐ½Ð¸ÑÐ¸Ð¸ÑÑÐµÑ Ð¾ÑÐ¿ÑÐ°Ð²ÐºÑ SMS-ÐºÐ¾Ð´Ð° ÐºÐ»Ð¸ÐµÐ½ÑÑ Ð´Ð»Ñ Ð¿Ð¾Ð»ÑÑÐµÐ½Ð¸Ñ ÑÐ¸ÑÑÐ¾Ð²Ð¾Ð³Ð¾ ÑÐ´Ð¾ÑÑÐ¾Ð²ÐµÑÐµÐ½Ð¸Ñ
// Ð»Ð¸ÑÐ½Ð¾ÑÑÐ¸ ÑÐµÑÐµÐ· ÑÐµÑÐ²Ð¸Ñ ÐÐÐ FCB ID OTP. ÐÑÐµ Ð¾Ð±ÑÐ°ÑÐµÐ½Ð¸Ñ Ðº Ð²Ð½ÐµÑÐ½ÐµÐ¼Ñ ÐÐÐ Ð²ÑÐ¿Ð¾Ð»Ð½ÑÐµÑ
// backend, ÑÑÐ´Ð° Ð¿ÐµÑÐµÐ´Ð°ÑÑÑÑ ÑÐ¾Ð»ÑÐºÐ¾ id ÑÐ¶Ðµ ÑÑÑÐµÑÑÐ²ÑÑÑÐµÐ³Ð¾ ÐºÐ»Ð¸ÐµÐ½ÑÐ° Doscar.
const pkbFcbSendCode = (id) => {
  return api.post(`/api/crm/clients/${id}/fcbid/send-code`);
};

export default pkbFcbSendCode;
